module.exports = __webpack_public_path__ + "img/gestoOla.1eb77cc9.png";